import { PartnerProgramService } from '@/services/partner-program.service';
import { useQuery } from '@tanstack/react-query';

export function useFetchPartnerProgram(productId: string) {
  const { data, isLoading, refetch } = useQuery({
    queryKey: ['partner-program', productId],
    queryFn: () => PartnerProgramService.getPartnerProgram(productId),
    enabled: !!productId,
    staleTime: 30 * 1000,
  });

  return {
    partnerProgram: data?.data ?? null,
    isLoading,
    refetch,
  };
}
